var _style, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcGwmLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:black;}\n\t.st1{fill:black;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1_00000000929349795850040680000011502056093892171659_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Legend-Expanded",
    transform: "translate(-596.000000, -634.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(586.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tag-_x2B_-Component-Copy",
    transform: "translate(0.000000, 402.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st0",
    d: "M51.4,38.8c0.8,0,1.4-0.4,1.6-1l3.4-14.7c0.2-0.4,0.2-0.8,0.2-1.1c0-1.6-1.3-2.9-3-2.9H6.4 c-0.7,0-1.3,0.2-1.9,0.6c-1.3,0.9-1.4,2.4-0.9,3.5l3.2,14.7c0.3,0.7,0.9,1,1.6,1H51.4z"
  })))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 21.4,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 21.4,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 21.4,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 21.4,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9,
    y: 21.4,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7,
    y: 21.4,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42.2,
    y: 21.4,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 21.4,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 33.6,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 33.6,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 33.6,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 33.6,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9,
    y: 33.6,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7,
    y: 33.6,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 42.2,
    y: 33.6,
    className: "st1",
    width: 3.9,
    height: 2.8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 33.6,
    className: "st1",
    width: 3.9,
    height: 2.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGwmLight);
export default __webpack_public_path__ + "static/media/ic-gwm-light.5e6c5851e65786ee4c7893a40e04cb4d.svg";
export { ForwardRef as ReactComponent };